import logo from '../media/logo.svg';
import '../css/login.css';
import { useLanguage } from '../providers/preferenceProvider';
import { useToast } from '../providers/toastProvider';
import { getPasswordReset, confirmPasswordReset } from '../api/password-api';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RegisterPassword = () => {
  const { t } = useLanguage();
  const { showToast } = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const PasswordResetId = urlParams.get('passwordResetId');

  useEffect(() => {
    if (!PasswordResetId) {
      navigate('/');
      return;
    }

    getPasswordReset(PasswordResetId)
      .then((response) => {
        if (response && response.data) {
          setEmail(response.data.email);
          setName(response.data.firstname); 
        } else {
          navigate('/');
        }
      })
      .catch((error) => {
        console.error('Error fetching password reset data:', error);
        navigate('/');
      });
  }, []);

  const handlePasswordReset = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      showToast(t.toast.password_mismatch, 'error');
      return;
    }

    confirmPasswordReset(PasswordResetId, password)
      .then(() => {
        showToast(t.toast.password_reset_complete.replace("{ph_name}", name), 'success');
        navigate('/');
      })
  }

  return (
    <>
      <div>
        <main className="main-container">
          <div className="login-box">
            <div className="main-header">{t.reset_password}</div>
            <div className="form-container">
              <div className="login-content">
                <div className="reset-password-message">{t.reset_password_message.replace("{ph_name}", name)}</div>
                <form className="login-form" onSubmit={handlePasswordReset}>
                  <input type="text" value={email} readOnly />
                  <input type="password" placeholder={t.password + "..."} onChange={e => setPassword(e.target.value)} required />
                  <input type="password" placeholder={t.confirm_password + "..."} onChange={e => setConfirmPassword(e.target.value)} required />
                  <button type="submit">{t.reset_password}</button>
                </form>
              </div>
              <div className="login-logo">
                <img src={logo} alt="42Workspace" />
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default RegisterPassword;
